module.exports = __webpack_public_path__ + "static/media/images.a1215fbf.png";